import { TCommonError } from "@models/common";
import {
  TInventoryProgressReq,
  TInventoryProgressResponse,
} from "@models/inventoryProgress";
import { TAxiosResponse } from "types";
import { axiosInstance } from "./axiosInstance";

/**
 * Service layer for VAMS_PC_009 (進捗確認 — Progress Confirmation).
 * Contract: vams_docs/Tasks/PC009/api-integration.md §2.1.
 * Status: ĐÃ CÓ ở BE (InventoryProgressController.GetProgress).
 *
 * Dropdown lookups:
 *   - §3.1 年月   GET /api/v1/inventory/sessions        — dùng chung inventorySessionApi.getSessions() (VAMS_PC_004)
 *   - §3.2 会社   GET api/v1/company                    — dùng chung layoutApi.getCompanies() (VAMS_PC_004)
 *   - §3.3 店舗   GET /api/v1/store?CompanyCode=...      — dùng chung layoutApi.getStoresByCompany() (VAMS_PC_004)
 * Xem pages/ProgressReviewPage/hooks/useProgressReviewPage.tsx (fetchYearMonths/fetchCompanies/fetchStores).
 */
const inventoryProgressApi = {
  /**
   * GET /api/v1/inventory/progress — 進捗データ取得.
   *
   * - companyCode="ALL" hoặc để trống → 全会社 (omit param từ request).
   * - storeCode="" hoặc để trống      → 全店舗 (omit param từ request).
   * - sortDirection: false=ASC, true=DESC (OI-API-03: bool? — api-integration.md §2).
   */
  getProgress: async (payload: TInventoryProgressReq) => {
    const response: TAxiosResponse<TInventoryProgressResponse, TCommonError> =
      await axiosInstance.get("/api/v1/inventory/progress", {
        params: {
          inventoryYearMonth: payload.inventoryYearMonth || undefined,
          sessionCode: payload.sessionCode || undefined,
          companyCode:
            payload.companyCode && payload.companyCode !== "ALL"
              ? payload.companyCode
              : undefined,
          storeCode: payload.storeCode || undefined,
          sortBy: payload.sortBy || undefined,
          sortDirection:
            payload.sortBy !== undefined ? payload.sortDirection : undefined,
        },
      });
    return response;
  },
};

export { inventoryProgressApi };
